// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// BOU-1035: design-system tokens (--ft-*) must load before ./index.css so the
// --gaia-color-* aliases in index.css can resolve via var(--ft-*). Imported
// through the JS module pipeline because Vite's PostCSS @import path resolver
// chokes on the bare specifier in dev mode.
import '@fabletable/design-system'
import './fonts.js'
import './index.css'
import AppWithAuth0 from './AppWithAuth0.jsx'
import { captureException, initSentry } from './monitoring/sentry.js'
import { recoverFromAppLoadFailure, showFallbackScreen } from './utils/runtimeRecovery.js'

// Store the root instance
let rootInstance = null;

initSentry();

// Global error handler for the entire app
window.addEventListener('error', (event) => {
  console.error('Main.jsx caught global error:', event.error);

  const recovery = recoverFromAppLoadFailure(event.error, {
    root: document.getElementById('root'),
    rootInstance,
  });
  if (recovery.handled) {
    event.preventDefault?.();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Main.jsx caught unhandled promise rejection:', event.reason);
  const recovery = recoverFromAppLoadFailure(event.reason, {
    root: document.getElementById('root'),
    rootInstance,
  });
  if (recovery.handled) {
    event.preventDefault?.();
  }
});

try {
  rootInstance = createRoot(document.getElementById('root'));
  rootInstance.render(
    // StrictMode disabled temporarily to prevent Socket.IO reconnection loops in dev
    // <StrictMode>
      <AppWithAuth0 />
    // </StrictMode>,
  )
} catch (error) {
  console.error('Error during app initialization:', error);
  // Caught exceptions are invisible to Sentry's GlobalHandlers — report explicitly
  captureException(error, { tags: { source: 'main.init' } });
  const root = document.getElementById('root');
  if (root) {
    showFallbackScreen(root, 'Something Went Wrong',
      error?.message || 'The application failed to initialize. Please try refreshing.');
  }
}
